let Api = {
	"BIGDATA_BASIC_DATEINIT": "/simple-api/w/xl/bigdata/basic/dateInit", //基础资源数据初期化
	"BIGDATA_BASIC_PROCESSSAVE": "/simple-api/w/xl/bigdata/basic/processSave", //山楂加工产业发展情况保存
	"BIGDATA_BASIC_PLANTSAVE": "/simple-api/w/xl/bigdata/basic/plantSave", //山楂种植产业发展情况保存
	"BIGDATA_BASIC_PLANTBASESAVE": "/simple-api/w/xl/bigdata/basic/plantBaseSave", //认证基地发展情况保存
	"BIGDATA_BASIC_PROCESSPRODSAVE": "/simple-api/w/xl/bigdata/basic/processProdSave", //山楂加工产业-加工产品发展情况保存
	"BIGDATA_BASIC_BASICSAVE": "/simple-api/w/xl/bigdata/basic/basicSave", //山楂产品销售情况保存
    "BIGDATA_BASIC_PRICE_TIMEAXISINIT": "/simple-api/w/xl/bigdata/basic/timeAxisInit", //资源时间初始化
    "BIGDATA_BASIC_PRICE_TIMEAXISSAVE": "/simple-api/w/xl/bigdata/basic/timeAxisSave", //资源时间保存

    // 资源分布
    "BIGDATA_BASIC_TIMEALL": "/simple-api/w/xl/bigdata/basic/timeAll", //时间轴列表
    "BIGDATA_BASIC_CAPACITYFIND": "/simple-api/w/xl/bigdata/couCapacity/findListCapacity", //资源分布初始化
    "BIGDATA_BASIC_CAPACITYUPDATE": "/simple-api/w/xl/bigdata/couCapacity/updateCapacity", //资源分布初始化修改
    "BIGDATA_COUCAP_AREALIST": "/simple-api/w/xl/bigdata/couCapacity/findAreaList", //乡镇列表初始化查询
    
    // 资源价格
    "BIGDATA_BASIC_PRICE_FINDBYYEAR": "/simple-api/w/xl/bigdata/purchasePrice/findByYear", //资源分布初始化
    "BIGDATA_BASIC_PRICE_DELETE": "/simple-api/w/xl/bigdata/purchasePrice/delete", //资源分布初始化删除
    "BIGDATA_BASIC_PRICE_FINALLVARIETY": "/simple-api/w/xl/bigdata/purchasePrice/findAllVariety", //查询品种列表
    "BIGDATA_BASIC_PRICE_SAVE": "/simple-api/w/xl/bigdata/purchasePrice/saveOrUpdate", //资源分布初始化新增/修改
    
    // 大数据配置

    "BIGDATA_BASIC_PRICE_CONFIG_SAVE": "/simple-api/w/bigDataPageLayout/addAndUpd", //大数据配置新增/修改
    "BIGDATA_BASIC_PRICE_CONFIG_FIND_DETAIL": "/simple-api/n/bigDataPageLayout/findBigDataPageLayout", //大数据配置查询详情
    "BIGDATA_BASIC_PRICE_CONFIG_FIND_LIST": "/simple-api/w/bigDataPageLayout/findList", //大数据配置列表

}
module.exports = Api